import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  prompt: React.ReactNode
}

const LinkToMemberships: React.FC<Props> = memo(({ prompt }) => {
  const { t } = useTranslation()
  return (
    <span>
      {prompt}, {t('subscribe_memberships')}{' '}
      <a href="/subscription/purchase" target="blank">
        {t('memberships')}
      </a>{' '}
      {t('now')}
    </span>
  )
})

export default LinkToMemberships
